<template>
  <div class="p-3 card mb-3">
    <FccTratamentoCandidatosBusca
      :cidades-de-prova="cidadesDeProva"
      :colegios="colegios"
      :salas="salas"
      @buscar-colegios="listarColegios"
      @buscar-salas="listarSalas"
      @buscar="buscar"
    />
    <FccTratamentoCandidatosTabela
      :candidatos="candidatos"
      v-if="candidatos.length > 0"
      @atualizar="atualizaLocalDoCandidato"
      @excluir="excluirCandidatoLocalExame"
    />
    <FccAlteracoesCandidatos
      :alteracoes-candidatos="alteracoesCandidatos"
      v-if="alteracoesCandidatos.lenght > 0"
    />
  </div>
</template>
<script>
import FccAlteracoesCandidatos from './fccAlteracoesCandidatos.vue'
import FccTratamentoCandidatosBusca from './fccTratamentoCandidatosBusca.vue'
import FccTratamentoCandidatosTabela from './fccTratamentoCandidatosTabela.vue'
import axios from 'axios'
import store from '../../../../../store'

export default {
  components: {
    FccTratamentoCandidatosBusca,
    FccTratamentoCandidatosTabela,
    FccAlteracoesCandidatos
  },
  props: ['cidadesDeProva'],
  data() {
    return {
      colegios: [],
      salas: [],
      candidatos: [],
      alteracoesCandidatos: [],
      parametrosDeBusca: null
    }
  },
  computed: {
    configuracao() {
      return store.state.localDeProva.configuracao
    }
  },
  watch: {
    configuracao() {
      this.listarAlteracoesCandidatos()
    }
  },
  created() {
    this.listarAlteracoesCandidatos()
  },
  methods: {
    leftPad(number, width, pad = '0') {
      return number.toString().padStart(width, pad)
    },
    listarColegios(codCidExame) {
      const cidade = this.cidadesDeProva.find((elem) => elem.codcidexame === codCidExame)

      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          store.state.baseUrlLocalDeProva +
            `Colegio/ListarTratamentoColegioCandidatosCidade/${cidade.iddatacidade}`,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.colegios = response.data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    listarSalas(codvirtual) {
      const colegio = this.colegios.find((elem) => elem.codvirtual === codvirtual)

      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          store.state.baseUrlLocalDeProva +
            `Colegio/ListarSalaTratamentoCandidatoColegioPorIdDataColegio/${colegio.iddatacolegio}`,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.salas = response.data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    buscar(data) {
      this.parametrosDeBusca = {
        cidade: data.cidade,
        colegio: data.colegio,
        sala: data.sala
      }

      const body = {
        idLocalConfig: this.configuracao.idlocalconfig,
        codCidExame: data.cidade,
        codVirtual: `${data.colegio}`,
        sala: `${this.leftPad(data.sala, 4)}`
      }

      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .post(
          store.state.baseUrlLocalDeProva + `Colegio/BuscaSalaCandidato`,
          body,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          if (response.data.length === 0) {
            this.callAlert('A busca não retornou resultados.', '', 'error', 'error')
          }

          this.candidatos = response.data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    atualizaLocalDoCandidato(candidatos) {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .put(
          store.state.baseUrlLocalDeProva + `Colegio/AtualizaLocalDoCandidato`,
          candidatos,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.callToast('Atualizado com sucesso', 'success')
          this.buscar(this.parametrosDeBusca)
          this.listarAlteracoesCandidatos()
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    excluirCandidatoLocalExame(candidatos) {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .put(
          store.state.baseUrlLocalDeProva + `Colegio/ExcluirCandidatoLocalExame`,
          candidatos,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.callToast(this.mensagensUpdate.excluido, 'success')
          this.buscar(this.parametrosDeBusca)
          this.listarAlteracoesCandidatos()
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    listarAlteracoesCandidatos() {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          store.state.baseUrlLocalDeProva +
            `Colegio/ListaCandidatosAtualizado/${this.configuracao.idlocalconfig}`,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.alteracoesCandidatos = response.data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    }
  }
}
</script>